import { gql } from '@apollo/client';

import { useSupportedLocalesQuery } from 'src/generated/mloop-graphql';

// Resolves `thisOrg.supportedLocales` on the recruiting (employee-scheduler) schema. The backend
// already normalizes the list and includes the org default. The interviewer portal has its own
// query (InterviewerSupportedLocalesProvider) against the interviewer schema/client, so this hook
// is recruiting/main-app only — do not reuse it inside the interviewer portal.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const SupportedLocalesGqlQuery = gql`
  query SupportedLocales {
    thisOrg {
      id
      supportedLocales
    }
  }
`;

/** Org-enabled locales on the recruiting schema. */
export function useSupportedLocales() {
  return useSupportedLocalesQuery();
}
